<template>
    <v-dialog v-model="dialog.show" persistent max-width="600px">
        <v-card class="ui-card">
            <div class="ui-card__header">
                <div>
                    <h3 class="ui-section-title">Adicionar Edital</h3>
                    <p class="ui-section-description">Informe o nome do edital e selecione o arquivo para envio.</p>
                </div>
            </div>
            <div class="ui-card__body">
                <v-text-field
                    v-model="dataset.data.name"
                    dense
                    outlined
                    label="Nome do edital"
                    hide-details="auto"
                    :rules="[v => !!v || 'Nome do edital é obrigatório']"
                ></v-text-field>
                <v-file-input ref="fileInput" class="mt-3" dense outlined show-size hide-details="auto" truncate-length="40" label="Arquivo" prepend-icon=""
                    @change="onFileSelected($event)">
                </v-file-input>
                <v-progress-linear v-model="dataset.progress" class="mt-4" color="primary" height="20" rounded
                    reactive>
                    <span class="ui-small">{{ dataset.progress }} %</span>
                </v-progress-linear>
            </div>
            <div class="ui-card__footer">
                <v-btn text @click.native="goBack">Cancelar</v-btn>
                <v-btn v-if="$allowed('edit')" @click="uploadFile" color="primary" depressed :loading="dataset.loading">
                    Enviar
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>


<script>
import 'moment/locale/pt-br';

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import string from "@/common/util/string"

Vue.use(VueLodash)

export default {

    name: "upload-files",

    data() {
        return {
            dataset: {
                data: {
                    id: null,
                    name: '',
                    file: undefined,
                },
                progress: null,
                loading: false,
            },
            data: [],
            dialog: {
                show: false,
                resolve: null,
                reject: null,
            },
        }
    },

    methods: {

        open() {
            this.dialog.show = true;

            return new Promise((resolve, reject) => {
                this.dialog.resolve = resolve;
                this.dialog.reject = reject;
            });
        },

        close() {
            this.dialog.show = false;
            this.dialog.resolve()
        },

        setData(data) {
            this.dataset.data.id = data.id;
            this.dataset.data.name = '';
            this.dataset.data.file = undefined;
        },

        goBack() {
            this.dataset.data.name = '';
            this.dataset.data.file = undefined;
            if (this.$refs.fileInput) {
                this.$refs.fileInput.reset();
            }
            this.close();
        },

        onFileSelected(file) {
            this.dataset.progress = 0;
            this.dataset.data.file = file;
        },


        async uploadFile() {

            if (!this.dataset.data.name || !this.dataset.data.name.trim()) {
                this.$dialog.notify.error("Informe o nome do edital!", { position: "top-right", timeout: 5000 });
                return;
            }

            if (!this.dataset.data.file) {
                this.$dialog.notify.error("Selecione um arquivo para ser enviado!", { position: "top-right", timeout: 5000 });
                return;
            }

            let formData = new FormData();
            formData.append("name", this.dataset.data.name);
            formData.append("file", this.dataset.data.file);

            const id = this.dataset.data.id;

            this.dataset.loading = true;
            this.dataset.progress = 0;

            try {
                const response = await axios.post(`/api/admin/general-meetings/${id}/notices`, formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        this.dataset.progress = Math.round((100 * event.loaded) / event.total);
                    }
                })

                this.$dialog.notify.info("Edital adicionado com sucesso!", { position: "top-right", timeout: 5000 });

                this.goBack()

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }

            this.dataset.progress = 0;
            this.dataset.data.file = undefined;

        },

    }

};
</script>


<style>
.button {
  margin-right: 10px;
}

.title-page {
    color: var(--v-primary-base);
    font-family: "Raleway";
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

</style>
